module.exports = __webpack_public_path__ + "media/images/upload_2-3718ef1b.png";